import React from "react";
import { Flex, Box, Center } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { useDisclosure } from "@chakra-ui/react";
import { Icon } from '@iconify/react';
import { SideNavDrawer } from "./SideNavDrawer";
import NavElement from '../custom/NavElement'
import CustomButton from "../custom/Button";
import Logo from "../brand/Logo";

const TopNav = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <NavElement>
      <Box h='70px' w='100%' bg={['#37A75B']}>
        <Flex
          alignItems='center' justifyContent='space-between'
          h='70px' px={[6]}
        >
          <Box
            display={{ md: "none" }}
            w='100%' maxW={{ base: '14rem', lg: '15rem' }}
          >
            <Center w="fit-content" h="70px">
              <Link to='/dashboard'>
                <Logo
                  color='white' fontSize="2xl"
                  imgSize="45px"
                />
              </Link>
            </Center>
          </Box>

          <Box display={{ md: "none" }}>
            <CustomButton onClick={onOpen}>
              {isOpen ?
                <Icon
                  icon="ic:round-close" color="white"
                  width="27" height="27"
                /> :
                <Icon
                  icon="iconamoon:menu-burger-horizontal-bold"
                  color="white" width="27" height="27"
                />
              }
            </CustomButton>
          </Box>
        </Flex>

        {/* Drawer Component >>> */}
        <SideNavDrawer
          isOpen={isOpen}
          onClose={onClose}
        />
        {/* Drawer Component <<< */}
      </Box>
    </NavElement>
  )
}

export default TopNav